import ConfigurazioneMedicoListPage from "./pages/ConfigurazioneMedicoListPage";
import ConfigurazioneMedicoEditPage from "./pages/ConfigurazioneMedicoEditPage";
export default {
  ConfigurazioneMedicoListPage,
  ConfigurazioneMedicoEditPage
};
